<template>
<div>
  <div v-if="type === 'file'" :class="className">
    <input
      :type="type"
      :id="id"
      :placeholder="placeholder"
      :value="value">
    <span class="c-input__file-name">{{ fileName }}</span>
    <label :for="id" class="c-input__file-btn">Upload</label>
  </div>
  <input v-else :type="type" :class="className" :placeholder="placeholder" :value="value">
</div>
</template>

<script>

export default {
  name: 'Input',
  props: {
    type: String,
    className: String,
    id: String,
    placeholder: String,
    value: String,
    fileName: String
  }
}
</script>

<style lang="scss" scoped>
.c-input {
  box-sizing: border-box;
  &__url {
    @extend .c-input;
    width: 500/1280*100vw;
    height: 50px;
    padding: 0 15px;
    border-radius: 50px;
    box-shadow: $bs_inset;
    @include media-queries-sp {
      width: 100%;
      margin-bottom: 30px;
    }
  }

  &__file {
    @extend .c-input;
    width: 500/1280*100vw;
    height: 50px;
    padding: 0 5px 0 15px;
    border-radius: 50px;
    box-shadow: $bs_inset;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include media-queries-sp {
      width: 100%;
      margin-bottom: 30px;
    }

    &-btn {
      width: 100px;
      height: 40px;
      color: #fff;
      font-weight: 700;
      font-size: 1.6rem;
      line-height: 3.8rem;
      text-align: center;
      background: $color_blue;
      border-radius: 40px;
      box-shadow: $bs_default;
      transition-duration: .3s;
      &:hover {
        background: $color_blue_dark;
        box-shadow: $bs_learge;
      }
    }

    &-name {
      width: calc(100% - 110px);
      height: 2rem;
      color: $color_gray;
      font-size: 1.4rem;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  &__color {
    @extend .c-input;
    width: 200/1280*100vw;
    min-height: 50px;
    border: none;
    box-shadow: $bs_default;
    background: #fff;
    border-radius: 10px;
    position: relative;
    transition-duration: .3s;
    @include media-queries-sp {
      width: 100%;
    }
    &::-webkit-color-swatch {
      border: none;
      border-radius: 10px;
    }
    &::-webkit-color-swatch-wrapper{
      padding: 0;
      border-radius: 10px;
    }
    &:hover{
      box-shadow: $bs_learge;
    }
    &::after {
      content: '';
      width: 24/1280*100vw;
      height: 24/1280*100vw;
      background-image: url('/assets/img/ic_spoit.png');
      background-size: cover;
      position: absolute;
      top: 8px;
      right: 8px;
      @include media-queries-sp {
        width: 24/375*100vw;
        height: 24/375*100vw;
      }
    }
  }
}
</style>
